import { environment } from '../../../environments/environment';
import { CollectionReference, Query } from "@angular/fire/compat/firestore";
import { AuthNZService } from '../authnz.service';
import log from 'loglevel'
import { TextableUser } from 'src/app/backported_types/users';
import { UISecurityProvider } from './interfaces';

export class BaseSecurityProvider implements UISecurityProvider {
  
  protected service: AuthNZService;
  protected orgsUserManages: string[];
  private activeNumber: TextableUser;
  private loggedInUser: TextableUser;

  constructor(service: AuthNZService) {
    this.service = service;
    this.service.activeNumberProfile$.subscribe((user) => {
      this.activeNumber = user;
    });
    this.service.loggedInUserProfile$.subscribe((user) => {
      this.loggedInUser = user;
    });
  }

  /**
   * Checks whether the current user has a restriction set on the given feature name
   * @param featureName the name of the feature to check; should correspond with array values in the `restrictions` property on User documents
   * @returns true if the feature is permitted; false if the feature is not permitted
   */
   protected getUserFeatureGrant(
    featureName: string,
    ContextCheck: "ActiveUser" | "ActiveNumber" = "ActiveNumber"
    ): boolean {
    const profileToCheck = (
      ContextCheck == "ActiveNumber" ? this.activeNumber : this.loggedInUser
      );
     //check activeUser.restrictions.includes(featureName) (activeUser check if they have permission)
     if (
      profileToCheck.restrictions 
       && profileToCheck.restrictions.includes(featureName)
       ) {
      return false;
    }
    return true;
  }

  /**
   * Checks whether the requested feature is allowable based on the current environment and user restrictions
   * @param featureName he name of the feature to check.
   * @returns true if both the environment and the current user grant access; false if either environment or user restrictions block access
   */
  protected getUserAndEnvironmentFeatureGrant(
    featureName: string,
    ContextCheck: "ActiveUser" | "ActiveNumber" = "ActiveNumber"
    ) {
    // Return true ONLY IF the environment permits the feature, 
    //  and the user (either current user or active number) is not restricted from the feature
    return this.getUserFeatureGrant(featureName, ContextCheck)
  }

  /**
   * Yes, this is a function which returns only true.  It exists so that instances of granting unconditional access are 
   * explicitly clear and readable; instead of letting the developer guess what "true" means in context.
   * @returns true
   */
  public unrestrictedGrant(): boolean {
    return true;
  }
  public canDeleteContacts(): boolean {
    return this.isUserFullOrSuperAdmin() || (!environment.disableDelete && this.getUserFeatureGrant("disableDelete"));
  }

  protected isUserFullOrSuperAdmin(): boolean {
    return this.loggedInUser.isAdmin || this.loggedInUser.isSuperAdmin;
  }

}